import { dashboardCount } from "../../helpers";
import {
  fetchDashboardStart,
  fetchDashboardSuccess,
  fetchDashboardFailure,
  setLoading,
  setError,
} from "./reducer";

let ongoingRequest = null;

export const fetchDashboardData = (params = {}) => async (dispatch) => {
  // Prevent multiple simultaneous requests
  if (ongoingRequest) {
    return ongoingRequest;
  }

  dispatch(fetchDashboardStart());
  dispatch(setLoading(true));

  const req = dashboardCount(params);
  ongoingRequest = req;

  ongoingRequest = (async () => {
    try {
      const response = await req;
      
      // Check if response structure is correct
      if (response?.status === 1) {
        const dashboardData = response.data;
        
        // Dispatch success with the full dashboard data
        dispatch(fetchDashboardSuccess(dashboardData));
        
      } else {
        const errorMessage = response?.message || "Failed to fetch dashboard data";
        console.error('API Error Response:', response);
        dispatch(fetchDashboardFailure(errorMessage));
        dispatch(setError(errorMessage));
      }

    } catch (err) {
      console.error('API Error:', err);
      const errorMessage = err.message || "Network error occurred";
      dispatch(fetchDashboardFailure(errorMessage));
      dispatch(setError(errorMessage));
    } finally {
      ongoingRequest = null;
      dispatch(setLoading(false));
    }
  })();

  return ongoingRequest;
};